<div class="exito">
    <h1>Registro exitoso</h1>
    <p>{{mensaje}}</p>
  </div>
